import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/IndexPage.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '汉伦 - 首页'
    },
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/AboutUsPage.vue'),
    meta: {
      title: '汉伦 - 关于我们'
    },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/ContactUsPage.vue'),
    meta: {
      title: '汉伦 - 联系我们'
    },
  },
  {
    path: '/clean',
    name: 'clean',
    component: () => import('../views/CleanPage.vue'),
    meta: {
      title: '汉伦 - 海外保洁'
    },
  },
  {
    path: '/maintain',
    name: 'maintain',
    component: () => import('../views/MaintainPage.vue'),
    meta: {
      title: '汉伦 - 海外维修'
    },
  },
  {
    path: '/moveHouse',
    name: 'moveHouse',
    component: () => import('../views/MoveHousePage.vue'),
    meta: {
      title: '汉伦 - 海外搬家'
    },
  },
  {
    path: '/pickUp',
    name: 'pickUp',
    component: () => import('../views/PickUpPage.vue'),
    meta: {
      title: '汉伦 - 海外接机'
    },
  },
  {
    path: '/management',
    name: 'management',
    component: () => import('../views/ManagementPage.vue'),
    meta: {
      title: '汉伦 - 物业管理'
    },
  },
  {
    path: '/directRent',
    name: 'DirectRent',
    component: () => import('../views/DirectRentPage.vue'),
    meta: {
      title: '汉伦 - 汉伦直租'
    },
  },
  {
    path: '/aparmentDetail',
    name: 'aparmentDetail',
    component: () => import('../views/AparmentDetail.vue'),
    meta: {
      title: '汉伦 - 公寓详情'
    },
  },
  {
    path: '/Procedure',
    name: 'Procedure',
    component: () => import('../views/Procedure.vue'),
    meta: {
      title: '汉伦 - 预定流程'
    },
  },
  {
    path: '/BrandStory',
    name: 'BrandStory',
    component: () => import('../views/BrandStoryPage.vue'),
    meta: {
      title: '汉伦 - 品牌故事'
    },
  },
  {
    path: '/article',
    name: 'article',
    component: () => import('../views/ArticlePage.vue'),
    meta: {
      title: '汉伦 - 资讯'
    },
  },
  {
    path: '/houseHosting/:id',
    name: 'houseHosting',
    component: () => import('../views/HouseHostingPage.vue'),
    meta: {
      title: '汉伦 - 房源详情'
    },
  },
  {
    path: '/management/step',
    name: 'step',
    component: () => import('../views/StepPage.vue'),
    meta: {
      title: '汉伦 - 购房流程'
    },
  },
  {
    path: '/houseList/:id',
    name: 'houseList',
    component: () => import('../views/HouseListPage.vue'),
    meta: {
      title: '汉伦 - 优质房源'
    },
  },
  {
    path: '/mapDetdil',
    name: 'mapDetdil',
    component: () => import('../views/MapDetdilPage.vue'),
    meta: {
      title: '汉伦 - 优质房源'
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
//重写路由规则
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  document.body.style.height = 'auto';
  document.body.style['overflow-y'] = 'auto';
  next()
});
router.afterEach(() => {
  window.scrollTo(0,0);  
});
export default router
